<template>
  <div>
    <RankTable ref="rankTable"/>
  </div>
</template>

<script>
import RankTable from '@/components/rank/RankTable.vue';

export default {
  components: {
    RankTable,
  },
};
</script>
